import { useEffect } from 'react';

import { usePublish } from '@atlaskit/rovo-triggers/main';

/**
 * Publishes the SmartLink subscription signal to the host app publisher
 * (e.g. Confluence's RovoSmartLinksContextPublisher).
 *
 * Should be called from a component with authoritative knowledge of whether
 * page context is active (e.g. ContextBanner which computes hasActiveEditorContext).
 *
 * @param isContextActive - true when the current page is added as Rovo context
 */
export const useSmartLinkSubscription = (isContextActive: boolean): void => {
	const publish = usePublish('ai-mate');

	useEffect(() => {
		publish({
			type: 'smartlinks-subscription-changed',
			source: 'conversation-assistant',
			isActive: isContextActive,
			openChat: false,
		});
	}, [isContextActive, publish]);
};
